var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-details" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "contain-left" }, [
        _c("span", { staticClass: "back", on: { click: _vm.goBack } }, [
          _c("i", {
            staticClass: "iconfont icon-fanhui",
            staticStyle: { "font-size": "24px" },
          }),
        ]),
        _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.productName))]),
        _c(
          "div",
          {
            staticClass: "status",
            class: { "dep-completed": _vm.developStatus == 1 },
          },
          [
            _c("div", { staticClass: "status-icon" }),
            _c("div", [
              _vm._v(_vm._s(_vm.developStatus == 1 ? "开发完成" : "开发中")),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: {
                disabled:
                  _vm.rolesCode !== "CUSTOM_ADMIN" &&
                  _vm.rolesCode !== "PRODUCT",
                type: "primary",
                size: "14",
              },
              on: { click: _vm.releaseProduct },
            },
            [_vm._v(_vm._s(_vm.developStatus == 1 ? "返回开发" : "发布产品"))]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "tabs" },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "div",
          {
            key: tab.index,
            staticClass: "tab-pane",
            class: [{ "tab-active": _vm.activeName === tab.index }],
            on: {
              click: function ($event) {
                return _vm.handleTabs(tab.index)
              },
            },
          },
          [
            _c("div", [
              _c("span", { staticClass: "num" }, [_vm._v(_vm._s(tab.num))]),
              _c("span", [_vm._v(_vm._s(tab.title))]),
            ]),
          ]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "contain" },
      [
        _vm._l(_vm.tabs, function (tab) {
          return [
            _vm.activeName === tab.index
              ? _c(tab.component, {
                  key: tab.index,
                  tag: "component",
                  attrs: { "develop-status": _vm.developStatus },
                  on: {
                    "update-develop-status": _vm.handleUpdateDevelopStatus,
                  },
                })
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }